import DecisionCondition from "./decision-condition";

/**
 * Copyright (c) 2016-2020 Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti
 * All Rights Reserved.
 *
 * The software and data contained herein are confidential and
 * proprietary information of Yega Yazilim ("Confidential Information").
 *
 * Users of this software may not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * they entered into with Yega Yazilim.
 *
 *
 * Author    Ahmet Dogramaci
 * Date      2020-03-12
 */
const ActionExpression =  {
    HIDE:'hide()',
    SHOW:'show()',
    SELECT:'select()',
    UNSELECT:'unselect()'
};
export const ACTION_EXPRESSION_OPTIONS=[
    {id:ActionExpression.HIDE,label:ActionExpression.HIDE},
    {id:ActionExpression.SHOW,label:ActionExpression.SHOW},
    {id:ActionExpression.SELECT,label:ActionExpression.SELECT},
    {id:ActionExpression.UNSELECT,label:ActionExpression.UNSELECT}
];
export default ActionExpression;